import { DatePicker as AntdDatePicker } from 'antd';
import dayjs from 'dayjs';
const { RangePicker: AntdRangePicker } = AntdDatePicker;

export const DatePicker = (props: any) => {
    const { value, defaultValue, ...rest } = props;
    const dateFormat = 'YYYYMMDD';
    const dateValue = value && (typeof value === 'string' || typeof value === 'number') ? dayjs(value) : value;
    const defaultDateValue = defaultValue && (typeof defaultValue === 'string' || typeof value === 'number') ? dayjs(defaultValue) : defaultValue;
    const customFormat = (value: any) => `${value.format(dateFormat)}`;
    return <AntdDatePicker value={dateValue} defaultValue={defaultDateValue} format={customFormat} {...rest} ></AntdDatePicker>;
};

export const RangePicker = (props: any) => {
    const { value, pickerValue, defaultValue, ...rest } = props;

    let dateValue = (value || pickerValue) && Array.isArray(value || pickerValue) ? (value || pickerValue) : [];
    dateValue = (
        (typeof dateValue?.[0] === 'string' || typeof dateValue?.[0] === 'number') &&
        (typeof dateValue?.[1] === 'string' || typeof dateValue?.[1] === 'number'))
        ? [dayjs(dateValue[0]), dayjs(dateValue[1])] : dateValue;

    let defaultDateValue = (defaultValue || pickerValue) && Array.isArray(defaultValue || pickerValue) ? (defaultValue || pickerValue) : [];

    defaultDateValue = (
        (typeof defaultDateValue?.[0] === 'string' || typeof defaultDateValue?.[0] === 'number')
        && (typeof defaultDateValue?.[1] === 'string' || typeof defaultDateValue?.[1] === 'number'))
        ? [dayjs(defaultDateValue[0]), dayjs(defaultDateValue[1])] : defaultDateValue;

    return <AntdRangePicker value={dateValue} defaultValue={defaultDateValue}  {...rest} ></AntdRangePicker>;
};